import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersPaymentMethodService {
  private paymentMethodSubject$$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  private shouldChargeOrderSubject$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get paymentMethod$(): Observable<string | null> {
    return this.paymentMethodSubject$$.asObservable();
  }

  get shouldChargeOrder$(): Observable<boolean> {
    return this.shouldChargeOrderSubject$$.asObservable();
  }

  setPaymentMethod(paymentMethod: string | null): void {
    this.paymentMethodSubject$$.next(paymentMethod);
  }

  setShouldChargeOrder(shouldCharge: boolean): void {
    this.shouldChargeOrderSubject$$.next(shouldCharge);
  }
}
